import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const TransactionRepayComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__transactionRepay"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6.5" fill="#DAE1F5" stroke="white" />
      <g clipPath="url(#clip0_3474_3826)">
        <path
          d="M10 8V9.33333C10 9.51014 9.92976 9.67971 9.80474 9.80474C9.67971 9.92976 9.51014 10 9.33333 10H4.66667C4.48986 10 4.32029 9.92976 4.19526 9.80474C4.07024 9.67971 4 9.51014 4 9.33333V8"
          stroke={colorVar}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.33337 6.33325L7.00004 7.99992L8.66671 6.33325"
          stroke={colorVar}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7 8V4" stroke={colorVar} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_3474_3826">
          <rect width="8" height="8" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TransactionRepay = withIcon(TransactionRepayComponent);
